import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.css']
})
export class CustomerDetailsComponent implements OnInit {

  constructor() {


  }
  navigate(elemnt: any) {
    elemnt.scrollIntoView({ behavior: 'smooth' })
  }

  ngOnInit(): void {
    $('#sidebar_icon').click(function () {
      $('body').toggleClass('sidebar_closed')
    })
    $('#sidebarMenu li a').click(
      function (e) {
        $('.active').removeClass('active').addClass('notSelectedTab');
        $(this).addClass('active').removeClass('notSelectedTab');

      });
    throw new Error('Method not implemented.');
  }


}
